import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import styleable from 'react-styleable';
import '../../../styles/core.scss';
import css from './index.scss';
import StudentCount from '../../student-count/index';
import Button from '../../button/index';
import messages from './messages';

const StudentCountFormatter = ({ dependentValues, handleOnAssignStudents, intl }) => {
    if (dependentValues.studentsCount === 0) {
        return (<Button
            containerClassName={css.assign}
            disabled={false}
            handleOnClick={() => handleOnAssignStudents(dependentValues.classroomId, dependentValues.name)}
            label={intl.formatMessage(messages.assignStudents)} />);
    }

    return (
        <StudentCount
            count={dependentValues.studentsCount} />
    );
};

StudentCountFormatter.propTypes = {
    dependentValues: PropTypes.object,
    handleOnAssignStudents: PropTypes.func,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(StudentCountFormatter));



// WEBPACK FOOTER //
// ./app/components/formatters/student-count-formatter/index.js